import React from 'react';
import PropTypes from 'prop-types';
import { useMantineTheme } from '@mantine/core';

/**
 * EuroFormatter is a formatter which simply passes strings trough and adds ' EUR', but
 * returns a dash for empty or null values.
 */
export const EuroFormatter = ({ value, disabled }) => {
  const { colorScheme, colors } = useMantineTheme();
  const styles = {
    span: {
      height: '100%',
      backgroundColor: disabled ? '#f1f1f1' : colorScheme === 'dark' ? colors.dark[6] : 'white',
      color: colorScheme === 'dark' ? '#fff' : '#000',
    },
  };

  return (
    <span className={`form-control ${disabled ? 'disabled' : ''}`} style={styles.span}>
      {value === '' || value === null || value === undefined ? '-' : value} EUR
    </span>
  );
};

EuroFormatter.propTypes = {
  value: PropTypes.number,
};
